var map = {
	"./aging.svg": "9622",
	"./anatomy.svg": "e501",
	"./biology.svg": "365e",
	"./clinical_medicine.svg": "aa3a",
	"./clinical_rotation.svg": "b524",
	"./collaborator.svg": "4469",
	"./communicator.svg": "7a40",
	"./dermatology.svg": "e82a",
	"./ebm.svg": "8a04",
	"./elective.svg": "9dc4",
	"./embryology.svg": "7bfc",
	"./emergency_medicine_anesthesia.svg": "f03a",
	"./ent.svg": "d9a0",
	"./general_practice.svg": "7899",
	"./gynaecology.svg": "daec",
	"./health_advocate.svg": "27cd",
	"./human_genetics.svg": "360c",
	"./hygiene.svg": "ba56",
	"./internal_medicine.svg": "2550",
	"./laboratory.svg": "a55c",
	"./leader.svg": "b39e",
	"./medical_english.svg": "0182",
	"./medical_ethics.svg": "a6f0",
	"./medical_expert.svg": "4ddc",
	"./medical_sociology.svg": "0c85",
	"./mentoring.svg": "5965",
	"./microbiology.svg": "4935",
	"./neurology.svg": "b784",
	"./none.svg": "f26d",
	"./nursing_skills.svg": "2c60",
	"./onboarding.svg": "f1f8",
	"./oncology_palliative_care.svg": "4636",
	"./ophthalmology.svg": "2cbb",
	"./pathology.svg": "90f6",
	"./pediatrics.svg": "8e46",
	"./pharmacology.svg": "2725",
	"./physics_chemistry_biochemistry.svg": "bc8c",
	"./physiology.svg": "fc40",
	"./practical_procedures_skills.svg": "5e04",
	"./professional.svg": "8da8",
	"./professionalism.svg": "0d53",
	"./psychiatry.svg": "fad1",
	"./research_track.svg": "ef05",
	"./scholar.svg": "a969",
	"./srl.svg": "262d",
	"./surgery.svg": "8540",
	"./traumatology.svg": "af6d",
	"./urology.svg": "fe3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4042";